import {Controller} from "@hotwired/stimulus";
import {Turbo} from "@hotwired/turbo-rails";

/**
 * Add the ability to sync the Browser's url query params
 * when an <a> is clicked. Util when the <a> is triggering a TurboStream response.
 */
export default class LinkController extends Controller {
  static values = {
    // Update the Browser's URL with the params
    syncUrlParams: Boolean,
  };

  static targets = [];

  onLinkClicked = (event) => {
    console.debug("LINK clicked", this.element.href);
    this.syncParams(new URL(this.element.href));
  }

  connect() {
    console.debug("LINK UTILS INIT");
    if (this.syncUrlParamsValue) {
      this.element.addEventListener('click', this.onLinkClicked, false);
    }
    // document.documentElement.addEventListener('turbo:before-fetch-request', this.beforeFetchRequest, false);
    // document.documentElement.addEventListener('turbo:before-fetch-response', this.beforeFetchResponse, false);
  }

  disconnect() {
    if (this.syncUrlParamsValue) {
      this.element.removeEventListener('click', this.onLinkClicked);
    }
  }


  syncParams(url) {
    console.debug('LINK  Sync URL Params', url.searchParams, url.searchParams.toString());
    const newUrl = new URL(window.location.href);

    url.searchParams.forEach((value, key) => {
      if (key === 'commit') {
        return;
      }

      newUrl.searchParams.set(key, value);
    });

    window.history.pushState(history.state, '', newUrl);
  }

}
